//Think5WhysExtensionDB
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import { useSelector, useDispatch } from "react-redux";
import Tooltip from '../../components/utils/Tooltip';
// import MainLayout from "../../layouts/MainLayout";
// import Notification from '../../components/utils/Notification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faShare, faSave, faPrint, faDiceOne, faDiceFour, faDiceFive, faDiceTwo, faDiceThree, faProjectDiagram, faHistory } from '@fortawesome/free-solid-svg-icons';
import FiveWhysInfoGraphics from './FiveWhysInfoGraphics';
import DialougeTreeInfoGraphics from './DialougeTreeInfoGraphics';
import BeforeAfterInfoGraphics from './BeforeAfterInfoGraphics';
import T5WInfographics1Image from '../../fivewhystemplates/T5WInfographics1.png';
import T5WInfographics2Image from '../../fivewhystemplates/T5WInfographics2.png';
import T5WInfographics3Image from '../../fivewhystemplates/T5WInfographics3.png';
import T5WInfographics4Image from '../../fivewhystemplates/T5WInfographics4.png';
import T5WInfographics5Image from '../../fivewhystemplates/T5WInfographics5.png';
import T5WBeforeAfterImage from '../../fivewhystemplates/T5WBeforeAfter.png';
import T5WDialougeTreeImage from '../../fivewhystemplates/T5WDialogueTree.png';
import './BoxAnimation.css';

const Think5WhysExtensionDB = () => {
  const authState = useSelector(state => state.authReducer);
  // const { extensionRoute} = useParams();
  const location = useLocation();

  const [records, setRecords] = useState([]);
  const [category, setCategory] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [fetchData, { loading }] = useFetch();
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";
  // const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const categories = [
  //   { label: 'Select Your Area / Category', value: '' },
  //   { label: 'Children & Family', value: 'Children & Family' },
  //   { label: 'e-commerce Sector', value: 'e-commerce Sector' },
  //   { label: 'Educational Institutions', value: 'Educational Institutions' },
  //   { label: 'Family Business', value: 'Family Business' },
  //   { label: 'General', value: 'General' },
  //   { label: 'Government Sector', value: 'Government Sector' },
  //   { label: 'Healthcare Sector', value: 'Healthcare Sector' },
  //   { label: 'Human Resource Department', value: 'Human Resource Department' },
  //   { label: 'IT Sector', value: 'IT Sector' },
  //   { label: 'Manufacturing Sector', value: 'Manufacturing Sector' },
  //   { label: 'Social', value: 'Social' },
  //   { label: 'Students', value: 'Students' },
  //   { label: 'Transportation and Logistics Sector', value: 'Transportation and Logistics Sector' }
  // ];
  const [oneView1, setOneView1] = useState(false);
  const [oneView2, setOneView2] = useState(false);
  const [oneView3, setOneView3] = useState(false);
  const [oneView4, setOneView4] = useState(false);
  const [oneView5, setOneView5] = useState(false);
  const [beforeAfter, setBeforeAfter] = useState(false);
  const [dialougeTree, setDialougeTree] = useState(false);
  const [oneViewFontSize, setOneViewFontSize] = useState(11);

  const extensionRouteInitialized = useRef(false);
  const extensionRoute = (location?.pathname || '').split('/').pop() || '';

  const [isPersonal, setIsPersonal] = useState('');

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/fivewhys-analysis-home");
  };

  useEffect(() => {
    if (extensionRoute && !extensionRouteInitialized.current) {
      // console.log("Inside Extension Route: ",extensionRoute);
      if (extensionRoute === 'think5whys-extension-my') {
        setIsPersonal(true);
      } else {
        setIsPersonal(false);
      }
      // console.log("isPersonal: ", isPersonal? "True" : "False");
      extensionRouteInitialized.current = true;
    }
  }, [extensionRoute]);


  useEffect(() => {
    // console.log("isPersonal: ", isPersonal ? "True" : "False");
  }, [isPersonal]);


  const fetchRecords = useCallback(async () => {
    try {
      const config = {
        url: isPersonal ? "/think5whysdb/extensiondb/my" : "/think5whysdb/extensiondb/example",
        method: "post",
        headers: { Authorization: authState.token },
        data: {userId: authState.user._id},
      };
      // console.log('Extension DB Config:', config);


      const data = await fetchData(config, { showSuccessToast: false });
      if (data && data.records) {
        setRecords(data.records);
      } else {
        console.error('No records found in the response:', data);
        setNotificationMessage('No records found for the selected category.');
      }
    } catch (error) {
      console.error('Error during fetching records:', error);
      setNotificationMessage('Failed to fetch records. Please try again later.');
    }
  }, [authState.token, fetchData, isPersonal]);

  useEffect(() => {
      fetchRecords();
  }, [fetchRecords]);

  const handleView = (rcaCode) => {
    setSelectedRecordId(prevId => (prevId === rcaCode ? null : rcaCode));
  };

  const handleRecordShare = (rcaCode) => {
    setSelectedRecordId(rcaCode);
  };

  const handleRecordSave = (rcaCode) => {
    setSelectedRecordId(rcaCode);
  };

  const handleRecordPrint = (rcaCode) => {
    setSelectedRecordId(rcaCode);
  };

  // const sortedRecords = [...records].sort((a, b) => new Date(b.date) - new Date(a.date));
  const sortedRecords = [...records].sort((a, b) => {
    if (a.category < b.category) {
      return -1;
    }
    if (a.category > b.category) {
      return 1;
    }
    return 0;
  });

  const handleOneView1 = () => {
    setOneView1(prevState => !prevState);
  };

  const handleOneView2 = () => {
    setOneView2(prevState => !prevState);
  };

  const handleOneView3 = () => {
    setOneView3(prevState => !prevState);
  };

  const handleOneView4 = () => {
    setOneView4(prevState => !prevState);
  };

  const handleOneView5 = () => {
    setOneView5(prevState => !prevState);
  };

  const handleDialougeTree = () => {
    setDialougeTree(prevState => !prevState);
  };

  const handleBeforeAfter = () => {
    setBeforeAfter(prevState => !prevState);
  };

  const formatDate = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false, weekday: 'short'
    };
    const jsDate = new Date(date);
    
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(jsDate);
    // console.log('Date parts:', parts); // Debugging line to log parts

    const weekdayPart = parts.find(part => part.type === 'weekday');
    const weekday = weekdayPart ? weekdayPart.value : '';

    return `${weekday} ${day}-${month}-${year}`;
};

return (
  <div className='min-h-screen [&_p]:text-white'>
    <header className="sticky top-0 z-50 bg-gray-900 border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
      <div className="flex flex-col justify-start">
        <div className="text-xl lg:text-2xl font-bold text-yellow-200">❓ 5Whys Analysis</div>
        <div className="text-[11px] lg:text-lg text-gray-200">
          Elevate Your Thinking From Why To Wisdom
        </div>
      </div>

      {/* Desktop user controls */}
      <div className="hidden md:flex items-center gap-3">
        {isLoggedIn ? (
          <>
            <div className="text-xs text-left text-blue-300">{userName}</div>
            <button
              onClick={handleLogout}
              className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
              title="Logout"
            >
              ⏻
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => navigate("/login")}
              className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
            >
              Login
            </button>
            <button
              onClick={() => navigate("/signup")}
              className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
            >
              Register
            </button>
          </>
        )}
      </div>

      {/* Mobile hamburger */}
      <button
        onClick={() => setIsMobileMenuOpen((s) => !s)}
        className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? "×" : "☰"}
      </button>
    </header>
    <div className="min-h-[80vh] mx-auto p-2 bg-gray-900 text-white rounded-xl shadow-lg w-full">
        <h3 className='text-xl py-2 text-yellow-200 flex justify-center items-center'>Think5Whys Details Example Database</h3>
        <p className='text-lg text-center text-white'>RootSolve: Identify & Act Now - Real Life Example</p>
        <div className="p-4 ml-2 mr-2 mt-2">
          {loading ? (
            <Loader />
          ) : (
            <div className='h-1/2'>
              {records.length === 0 ? (
                <div className='flex items-center justify-center gap-4 text-yellow-300'>
                  <span>No record found</span>
                </div>
              ) : (
                sortedRecords.map((record, index) => (
                  <div key={record._id} className='bg-black my-2 p-2 text-white rounded-md shadow-md'>
                    <div className='flex'>
                      <span className='font-medium'>#{index+1}. {record.category}{' / '}{record.subCategory}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(record._id)}>
                          <FontAwesomeIcon icon={faEye} />
                        </span>
                      </Tooltip>
                    </div>
                    {selectedRecordId === record._id && (
                      <div className='bg-black border border-gray-700 text-white px-4 py-4 mt-2'>
                        <h2 className=' text-yellow-400 rounded-md'><strong>Concern Details</strong></h2>
                        <p><strong>Code:</strong> {record.rcaCode}</p>
                        <div className='mt-4 mb-4'>
                          <Tooltip text={"One-View1"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                            onClick={() => handleOneView1(record._id, 1)}>
                              <FontAwesomeIcon icon={faDiceOne} />
                            </span>
                          </Tooltip>
                          {oneView1 && (
                            <FiveWhysInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={11} 
                              lineHeight={15} 
                              lineWidth={100}

                              startXTitle={50} 
                              startYTitle={50} 
                              startXProblemCode={50} 
                              startYProblemCode={60} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              
                              startXConcern={150} 
                              startYConcern={30} 
                              startXProblemStatement={150} 
                              startYProblemStatement={80} 
                              startXWhy1={150} 
                              startYWhy1={200} 
                              startXWhy2={150} 
                              startYWhy2={320} 
                              startXWhy3={150} 
                              startYWhy3={440} 
                              startXWhy4={150} 
                              startYWhy4={550}
                              startXWhy5={150} 
                              startYWhy5={660} 
                              startXRootCause={150} 
                              startYRootCause={780} 
                              imageSrc={T5WInfographics1Image} 
                              viewWidth={500}
                            />
                          )}
                          <Tooltip text={"One-View2"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleOneView2(record._id, 2)}>
                              <FontAwesomeIcon icon={faDiceTwo} />
                            </span>
                          </Tooltip>
                          {oneView2 && (
                            <FiveWhysInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={14} 
                              lineHeight={15} 
                              lineWidth={300}

                              startXTitle={10} 
                              startYTitle={50} 
                              startXProblemCode={10} 
                              startYProblemCode={60} 
                              startXCategory={10} 
                              startYCategory={90} 
                              startXSubCategory={10} 
                              startYSubCategory={110} 
                              
                              startXConcern={30} 
                              startYConcern={70} 
                              startXProblemStatement={30} 
                              startYProblemStatement={110} 
                              startXWhy1={30} 
                              startYWhy1={250} 
                              startXWhy2={30} 
                              startYWhy2={360} 
                              startXWhy3={30} 
                              startYWhy3={470} 
                              startXWhy4={30} 
                              startYWhy4={575}
                              startXWhy5={30} 
                              startYWhy5={690} 
                              startXRootCause={30} 
                              startYRootCause={780} 
                              imageSrc={T5WInfographics2Image} 
                              viewWidth={500}
                            />
                          )}
                          <Tooltip text={"One-View3"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleOneView3(record._id, 3)}>
                              <FontAwesomeIcon icon={faDiceThree} />
                            </span>
                          </Tooltip>
                          {oneView3 && (
                            <FiveWhysInfoGraphics
                            title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={14} 
                              lineHeight={30} 
                              lineWidth={500} 
                              startXTitle={30} 
                              startYTitle={60} 
                              startXProblemCode={30} 
                              startYProblemCode={60} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              startXConcern={30} 
                              startYConcern={65} 
                              startXProblemStatement={30} 
                              startYProblemStatement={140} 
                              startXWhy1={30} 
                              startYWhy1={340} 
                              startXWhy2={30} 
                              startYWhy2={510} 
                              startXWhy3={30} 
                              startYWhy3={710} 
                              startXWhy4={30} 
                              startYWhy4={900}
                              startXWhy5={30} 
                              startYWhy5={1080} 
                              startXRootCause={30} 
                              startYRootCause={1240} 
                              imageSrc={T5WInfographics3Image} 
                              viewWidth={800}
                            />
                          )}
                          <Tooltip text={"One-View4"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleOneView4(record._id, 4)}>
                              <FontAwesomeIcon icon={faDiceFour} />
                            </span>
                          </Tooltip>
                          {oneView4 && (
                            <FiveWhysInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={14} 
                              lineHeight={20} 
                              lineWidth={600} 
                              startXTitle={50} 
                              startYTitle={50} 
                              startXProblemCode={50} 
                              startYProblemCode={70} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              startXConcern={20} 
                              startYConcern={80} 
                              startXProblemStatement={90} 
                              startYProblemStatement={200} 
                              startXWhy1={90} 
                              startYWhy1={350} 
                              startXWhy2={90} 
                              startYWhy2={510} 
                              startXWhy3={90} 
                              startYWhy3={670} 
                              startXWhy4={90} 
                              startYWhy4={820}
                              startXWhy5={90} 
                              startYWhy5={975} 
                              startXRootCause={90} 
                              startYRootCause={1150} 
                              imageSrc={T5WInfographics4Image} 
                              viewWidth={800}
                            />
                          )}
                          <Tooltip text={"One-View5"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleOneView5(record._id, 5)}>
                              <FontAwesomeIcon icon={faDiceFive} />
                            </span>
                          </Tooltip>
                          {oneView5 && (
                            <FiveWhysInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={20} 
                              lineHeight={30} 
                              lineWidth={800} 
                              startXTitle={50}
                              startYTitle={50} 
                              startXProblemCode={50} 
                              startYProblemCode={70} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              startXConcern={25} 
                              startYConcern={60} 
                              startXProblemStatement={30} 
                              startYProblemStatement={120} 
                              startXWhy1={170} 
                              startYWhy1={330} 
                              startXWhy2={170} 
                              startYWhy2={470} 
                              startXWhy3={170} 
                              startYWhy3={650} 
                              startXWhy4={170} 
                              startYWhy4={800}
                              startXWhy5={170} 
                              startYWhy5={950} 
                              startXRootCause={30} 
                              startYRootCause={1140} 
                              imageSrc={T5WInfographics5Image} 
                              viewWidth={1000}
                            />
                          )}
                          <Tooltip text={"DialougeTree"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleDialougeTree(record._id, 4)}>
                              <FontAwesomeIcon icon={faProjectDiagram} />
                            </span>
                          </Tooltip>
                          {dialougeTree && (
                            <DialougeTreeInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              fontSize={10} 
                              lineHeight={10} 
                              lineWidth={600} 
                              startXTitle={50} 
                              startYTitle={50} 
                              startXProblemCode={77} 
                              startYProblemCode={32} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              startXConcern={20} 
                              startYConcern={80} 
                              startXProblemStatement={80} 
                              startYProblemStatement={50} 
                              startXWhy1={80} 
                              startYWhy1={680} 
                              startXWhy2={200} 
                              startYWhy2={680} 
                              startXWhy3={325} 
                              startYWhy3={680} 
                              startXWhy4={445} 
                              startYWhy4={680}
                              startXWhy5={570} 
                              startYWhy5={680} 
                              startXRootCause={80} 
                              startYRootCause={610} 

                              why11={record.why1reasons[0]?.details}
                              why21={record.why2reasons[0]?.details}
                              why31={record.why3reasons[0]?.details}
                              why41={record.why4reasons[0]?.details}
                              why51={record.why5reasons[0]?.details}
                              rootCause1={record.rcaCauses[0]?.details}
                              startXWhy11={80} 
                              startYWhy11={110} 
                              startXWhy21={200} 
                              startYWhy21={110} 
                              startXWhy31={325} 
                              startYWhy31={110} 
                              startXWhy41={445} 
                              startYWhy41={110}
                              startXWhy51={570} 
                              startYWhy51={110} 
                              startXRootCause1={695} 
                              startYRootCause1={110} 

                              why12={record.why1reasons[1]?.details}
                              why22={record.why2reasons[1]?.details}
                              why32={record.why3reasons[1]?.details}
                              why42={record.why4reasons[1]?.details}
                              why52={record.why5reasons[1]?.details}
                              rootCause2={record.rcaCauses[1]?.details}
                              startXWhy12={80} 
                              startYWhy12={210} 
                              startXWhy22={200} 
                              startYWhy22={210} 
                              startXWhy32={325} 
                              startYWhy32={210} 
                              startXWhy42={445} 
                              startYWhy42={210}
                              startXWhy52={570} 
                              startYWhy52={210} 
                              startXRootCause2={695} 
                              startYRootCause2={210} 

                              why13={record.why1reasons[2]?.details}
                              why23={record.why2reasons[2]?.details}
                              why33={record.why3reasons[2]?.details}
                              why43={record.why4reasons[2]?.details}
                              why53={record.why5reasons[2]?.details}
                              rootCause3={record.rcaCauses[2]?.details}
                              startXWhy13={80} 
                              startYWhy13={310} 
                              startXWhy23={200} 
                              startYWhy23={310} 
                              startXWhy33={325} 
                              startYWhy33={310} 
                              startXWhy43={445} 
                              startYWhy43={310}
                              startXWhy53={570} 
                              startYWhy53={310} 
                              startXRootCause3={695} 
                              startYRootCause3={310} 

                              why14={record.why1reasons[3]?.details}
                              why24={record.why2reasons[3]?.details}
                              why34={record.why3reasons[3]?.details}
                              why44={record.why4reasons[3]?.details}
                              why54={record.why5reasons[3]?.details}
                              rootCause4={record.rcaCauses[3]?.details}
                              startXWhy14={80} 
                              startYWhy14={410} 
                              startXWhy24={200} 
                              startYWhy24={410} 
                              startXWhy34={325} 
                              startYWhy34={410} 
                              startXWhy44={445} 
                              startYWhy44={410}
                              startXWhy54={570} 
                              startYWhy54={410} 
                              startXRootCause4={695} 
                              startYRootCause4={410}

                              why15={record.why1reasons[4]?.details}
                              why25={record.why2reasons[4]?.details}
                              why35={record.why3reasons[4]?.details}
                              why45={record.why4reasons[4]?.details}
                              why55={record.why5reasons[4]?.details}
                              rootCause5={record.rcaCauses[4]?.details}
                              startXWhy15={80} 
                              startYWhy15={510} 
                              startXWhy25={200} 
                              startYWhy25={510} 
                              startXWhy35={325} 
                              startYWhy35={510} 
                              startXWhy45={445} 
                              startYWhy45={510}
                              startXWhy55={570} 
                              startYWhy55={510} 
                              startXRootCause5={695} 
                              startYRootCause5={510}

                              imageSrc={T5WDialougeTreeImage} 
                              viewWidth={800}
                            />
                          )}
                          <Tooltip text={"BeforeAfter"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' 
                              onClick={() => handleBeforeAfter(record._id, 4)}>
                              <FontAwesomeIcon icon={faHistory} />
                            </span>
                          </Tooltip>
                          {beforeAfter && (
                            <BeforeAfterInfoGraphics
                              title={"Root Cause Analysis"}
                              problemCode={record.rcaCode}
                              category={record.category}
                              subCategory={record.subCategory}
                              concern={"NA"}
                              problemStatement={record.problemStatement}
                              why1={record.why1}
                              why2={record.why2}
                              why3={record.why3}
                              why4={record.why4}
                              why5={record.why5}
                              rootCause={record.rootCause}
                              solution={record.selectedLTSolutionRemarks}
                              fontSize={9} 
                              lineHeight={10} 
                              lineWidth={600} 
                              startXTitle={50} 
                              startYTitle={50} 
                              startXProblemCode={10} 
                              startYProblemCode={45} 
                              startXCategory={50} 
                              startYCategory={90} 
                              startXSubCategory={50} 
                              startYSubCategory={110} 
                              startXConcern={80} 
                              startYConcern={60} 
                              startXProblemStatement={60} 
                              startYProblemStatement={85} 
                              startXWhy1={100} 
                              startYWhy1={150} 
                              startXWhy2={100} 
                              startYWhy2={210} 
                              startXWhy3={100} 
                              startYWhy3={270} 
                              startXWhy4={100} 
                              startYWhy4={330}
                              startXWhy5={100} 
                              startYWhy5={400} 
                              startXRootCause={100} 
                              startYRootCause={450} 
                              startXSolution={60} 
                              startYSolution={520} 

                              problemKey={record.problemKeywords}
                              why1Key={record.why1Keywords}
                              why2Key={record.why2Keywords}
                              why3Key={record.why3Keywords}
                              why4Key={record.why4Keywords}
                              why5Key={record.why5Keywords}
                              rootCauseKey={record.rcaKeywords}
                              solutionKey={record.solutionKeywords}
                              startXWhy1Key={315} 
                              startYWhy1Key={145} 
                              startXWhy2Key={315} 
                              startYWhy2Key={210} 
                              startXWhy3Key={315} 
                              startYWhy3Key={270} 
                              startXWhy4Key={315} 
                              startYWhy4Key={330}
                              startXWhy5Key={315} 
                              startYWhy5Key={390} 
                              startXRootCauseKey={315} 
                              startYRootCauseKey={450} 

                              problemMea={record.problemMeasures}
                              why1Mea={record.why1Measures}
                              why2Mea={record.why2Measures}
                              why3Mea={record.why3Measures}
                              why4Mea={record.why4Measures}
                              why5Mea={record.why5Measures}
                              rootCauseMea={record.rcaMeasures}
                              solutionMea={record.solutionMea}
                              startXProblemMea={455} 
                              startYProblemMea={80} 
                              startXWhy1Mea={455} 
                              startYWhy1Mea={145} 
                              startXWhy2Mea={455} 
                              startYWhy2Mea={210} 
                              startXWhy3Mea={455} 
                              startYWhy3Mea={270} 
                              startXWhy4Mea={455} 
                              startYWhy4Mea={330}
                              startXWhy5Mea={455} 
                              startYWhy5Mea={390} 
                              startXRootCauseMea={455} 
                              startYRootCauseMea={450} 
                              startXSolutionMea={450} 
                              startYSolutionMea={540} 

                              problemOut={record.problemOutcome}
                              why1Out={record.why1Outcome}
                              why2Out={record.why2Outcome}
                              why3Out={record.why3Outcome}
                              why4Out={record.why4Outcome}
                              why5Out={record.why5Outcome}
                              rootCauseOut={record.rcaOutcome}
                              solutionOut={record.solutionOutcome}
                              startXProblemOut={610} 
                              startYProblemOut={80} 
                              startXWhy1Out={610} 
                              startYWhy1Out={145} 
                              startXWhy2Out={610} 
                              startYWhy2Out={210} 
                              startXWhy3Out={610} 
                              startYWhy3Out={275} 
                              startXWhy4Out={610} 
                              startYWhy4Out={330}
                              startXWhy5Out={610} 
                              startYWhy5Out={390} 
                              startXRootCauseOut={610} 
                              startYRootCauseOut={450} 
                              startXSolutionOut={610} 
                              startYSolutionOut={520} 
                              
                              imageSrc={T5WBeforeAfterImage} 
                              viewWidth={800}
                            />
                          )}
                        </div>
                        <div className='text-sm'>
                          <p><strong>Category:</strong> {record.category}</p>
                          <p><strong>Sub-category:</strong> {record.subCategory}</p>
                          <p><strong>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong>Why1:</strong> {record.why1}</p>
                          <p><strong>Why2:</strong> {record.why2}</p>
                          <p><strong>Why3:</strong> {record.why3}</p>
                          <p><strong>Why4:</strong> {record.why4}</p>
                          <p><strong>Why5:</strong> {record.why5}</p>
                          <p><strong>Root Cause:</strong> {record.rootCause}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Problem / Impact Definition </p>
                          <p><strong className='text-blue-500 mb-2'>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong className='text-blue-500 mb-2'>Impact Study</strong></p>
                          {record.impact && record.impact.map((impactItem, index) => (
                            <>
                            <div key={index}>
                              <p><strong>{impactItem.sn}. </strong> {impactItem.details}</p>
                            </div>
                            </>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Impact:</strong> {record.overallImpact}</p>
                          <p><strong className='text-blue-500 mb-2'>Impact On:</strong> {record.overallImpactOn}</p>
                          <p><strong className='text-blue-500 mb-2'>Impact Severity:</strong> {record.overallImpactSeverity}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.problemStatementRemarks}</p>
                          
                          <p className='text-yellow-200 rounded-md mt-4'>Complete Why1 Analysis</p>
                          <p><strong className='text-blue-500 mb-2'>Why1:</strong> {record.why1}</p>
                          <p><strong className='text-blue-500 mb-2'>Deciding Why1?</strong></p>
                          {record.why1reasons && record.why1reasons.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Why1:</strong> ({record.why1SelectedSN}) {record.why1SNSelectedReason}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.why1remarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Why2 Analysis</p>
                          <p><strong className='text-blue-500 mb-2'>Why2:</strong> {record.why2}</p>
                          <p><strong className='text-blue-500 mb-2'>Deciding Why2?</strong></p>
                          {record.why2reasons && record.why2reasons.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Why2:</strong> ({record.why2SelectedSN}) {record.why2SNSelectedReason}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.why2remarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Why3 Analysis</p>
                          <p><strong className='text-blue-500 mb-2'>Why3:</strong> {record.why3}</p>
                          <p><strong className='text-blue-500 mb-2'>Deciding Why3?</strong></p>
                          {record.why3reasons && record.why3reasons.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Why3:</strong> ({record.why3SelectedSN}) {record.why3SNSelectedReason}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.why3remarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Why4 Analysis</p>
                          <p><strong className='text-blue-500 mb-2'>Why4:</strong> {record.why4}</p>
                          <p><strong className='text-blue-500 mb-2'>Deciding Why4?</strong></p>
                          {record.why4reasons && record.why4reasons.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Why4:</strong> ({record.why4SelectedSN}) {record.why4SNSelectedReason}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.why4remarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Why5 Analysis</p>
                          <p><strong className='text-blue-500 mb-2'>Why5:</strong> {record.why5}</p>
                          <p><strong className='text-blue-500 mb-2'>Deciding Why5?</strong></p>
                          {record.why5reasons && record.why5reasons.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Why5:</strong> ({record.why5SelectedSN}) {record.why5SNSelectedReason}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.why5remarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Complete Root Cause Conclusion</p>
                          <p><strong className='text-blue-500 mb-2'>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong className='text-blue-500 mb-2'>Causes: </strong></p>
                          {record.rcaCauses && record.rcaCauses.map((reason, index) => (
                            <div key={index}>
                              <p><strong>{reason.sn} </strong> {reason.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Cause:</strong> {record.selectedCause}. {record.rootCause}</p>
                          <p><strong className='text-blue-500 mb-2'>Remarks:</strong> {record.rcaRemarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Decision Route</p>
                          <p><strong>Decision Path:</strong> 
                            {'Problem -> '}
                            {record.why1SelectedSN}{' ->'}
                            {record.why2SelectedSN}{' ->'}
                            {record.why3SelectedSN}{' ->'}
                            {record.why4SelectedSN}{' ->'}
                            {record.why1SelectedSN}{' -> Root Cause'}
                          </p>
                          <p><strong>1.</strong> {record.why1SNSelectedReason}</p>
                          <p><strong>2.</strong> {record.why2SNSelectedReason}</p>
                          <p><strong>3.</strong> {record.why3SNSelectedReason}</p>
                          <p><strong>4.</strong> {record.why4SNSelectedReason}</p>
                          <p><strong>5.</strong> {record.why5SNSelectedReason}</p>
                         
                          <p className='text-yellow-200 rounded-md mt-4'>Solution Suggestions</p>
                          <p><strong className='text-blue-500 mb-2'>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong className='text-blue-500 mb-2'>Root Cause:</strong>{record.rootCause}</p>
                          <p><strong className='text-blue-500 mb-2'>Solution Suggestions:</strong> </p>
                          {record.probableSolutions && record.probableSolutions.map((solution, index) => (
                            <div key={index}>
                              <p><strong>{solution.sn}. </strong> {solution.details}</p>
                            </div>
                          ))}
                          <p><strong className='text-blue-500 mb-2'>Selected Quick Fix Solution:</strong>Solution# {record.selectedQFSolution} {record.selectedQFSolutionRemarks}</p>
                          <p><strong className='text-blue-500 mb-2'>Selected Long Term Solution:</strong>Solution# {record.selectedLTSolution} {record.selectedLTSolutionRemarks}</p>

                          <p className='text-yellow-200 rounded-md mt-4'>Action Taken</p>
                          <p><strong className='text-blue-500 mb-2'>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong className='text-blue-500 mb-2'>Root Cause:</strong>{record.rootCause}</p>
                          <p><strong className='text-blue-500 mb-2'>Long Term Solution:</strong>Solution# {record.selectedLTSolution} {record.selectedLTSolutionRemarks}</p>
                          
                          <p className='text-yellow-200 rounded-md mt-4 mb-2'>Action Items</p>
                          {record.solutionActions && record.solutionActions.map((action, index) => (
                            <div key={index}>
                              <p className='bg-black border border-blue-500 rounded-lg px-2'><strong>{action.sn}</strong> {action.actionItem}</p>
                              <p><strong>Who:</strong> {action.who}</p>
                              <p><strong>Priority:</strong> {action.priority}</p>
                              <p><strong>Date:</strong> {new Date(action.startDate).toLocaleDateString()}
                                <strong> to: </strong> {new Date(action.endDate).toLocaleDateString()}
                              </p>
                              <p><strong>Status:</strong> {action.status}</p>
                              <p><strong>Remarks:</strong> {action.remarks}</p>
                            </div>
                          ))}

                          <p className='text-yellow-200 rounded-md mt-4'>Problem When Analysed & Aftereffect post solution indentification, suggested solution and actions taken</p>
                          <p><strong className='text-blue-500 mb-2'>Action / Study / Project / Analysis Start Date: </strong>{formatDate(record.openingDate)}</p>
                          <p><strong className='text-blue-500 mb-2'>Action / Study / Project / Analysis End Date: </strong>{formatDate(record.closingDate)}</p>
                          <div className='bg-black border border-red-300 p-4 mt-2'>
                            <p><strong className='text-blue-500 mb-2'>Problem</strong></p>
                            <p><strong>Statement: </strong> {record.problemStatement}</p>
                            <p><strong>Highlight: </strong> {record.problemKeywords}</p>
                            <p><strong>Measures Taken: </strong> {record.problemMeasures}</p>
                            <p><strong>Outcome: </strong> {record.problemOutcome}</p>
                          </div>
                          <div className='bg-black border border-gray-100 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Why1</strong></p>
                            <p><strong>Statement: </strong> {record.why1}</p>
                            <p><strong>Highlight: </strong> {record.why1Keywords}</p>
                            <p><strong>Measures Taken: </strong> {record.why1Measures}</p>
                            <p><strong>Outcome: </strong> {record.why1Outcome}</p>
                          </div>
                          <div className='bg-black border border-gray-200 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Why2</strong></p>
                            <p><strong>Statement: </strong> {record.why2}</p>
                            <p><strong>Highlight: </strong> {record.why2Keywords}</p>
                            <p><strong>Measures Taken: </strong> {record.why2Measures}</p>
                            <p><strong>Outcome: </strong> {record.why2Outcome}</p>
                          </div>
                          <div className='bg-black border border-gray-200 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Why3</strong></p>
                            <p><strong>Statement: </strong> {record.why3}</p>
                            <p><strong>Highlight: </strong> {record.why3Keywords}</p>
                            <p><strong>Measures Taken: </strong> {record.why3Measures}</p>
                            <p><strong>Outcome: </strong> {record.why3Outcome}</p>
                          </div>
                          <div className='bg-black border border-gray-200 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Why4</strong></p>
                            <p><strong>Statement: </strong> {record.why4}</p>
                            <p><strong>Highlight: </strong> {record.why4Keywords}</p>
                            <p><strong>Measures Taken: </strong> {record.why4Measures}</p>
                            <p><strong>Outcome: </strong> {record.why4Outcome}</p>
                          </div>
                          <div className='bg-black border border-gray-200 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Why5</strong></p>
                            <p><strong>Statement: </strong> {record.why5}</p>
                            <p><strong>Highlight: </strong> {record.why5Keywords}</p>
                            <p><strong>Measures Taken: </strong> {record.why5Measures}</p>
                            <p><strong>Outcome: </strong> {record.why5Outcome}</p>
                          </div>
                          <div className='bg-black border border-orange-500 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Root Cause</strong></p>
                            <p><strong>Statement: </strong> {record.rootCause}</p>
                            <p><strong>Highlight: </strong> {record.rcaKeywords}</p>
                            <p><strong>Measures Taken: </strong> {record.rcaMeasures}</p>
                            <p><strong>Outcome: </strong> {record.rcaOutcome}</p>
                          </div>
                          <div className='bg-black border border-teal-500 p-4'>
                            <p><strong className='text-blue-500 mb-2'>Solution</strong></p>
                            <p><strong>Statement: </strong> {record.selectedLTSolutionRemarks}</p>
                            <p><strong>Highlight: </strong> {record.solutionKeywords}</p>
                            <p><strong>Measures Taken: </strong> {record.solutionMeasures}</p>
                            <p><strong>Outcome: </strong> {record.solutionOutcome}</p>
                          </div>
                          <p className='mt-4 text-blue-600'><strong className='text-lg'>Final Analysis & Stakeholders</strong></p>
                          <div className='bg-black border border-blue-500 p-4'>
                            <p><strong>Opening Remarks: </strong>{record.openingRemarks} </p>
                            <p><strong>Closing Remarks: </strong>{record.closingRemarks} </p>
                            <p><strong>Expert Name: </strong> {record.expertName}</p>
                            <p><strong>Think5Whys Licence Number: </strong> {record.expertCode}</p>
                            <p><strong>Client Name: </strong> {record.clientName}</p>
                            <p><strong>Client Testimonial: </strong> {record.clientRemarks}</p>

                          </div>
                        </div>
                        <Tooltip text={"Share"} position={"top"}>
                          <span className='text-green-500 cursor-pointer mr-4' onClick={() => handleRecordShare(record._id)}>
                            <FontAwesomeIcon icon={faShare} />
                          </span>
                        </Tooltip>
                        <Tooltip text={"Save"} position={"top"}>
                          <span className='text-blue-500 cursor-pointer mr-4' onClick={() => handleRecordSave(record._id)}>
                            <FontAwesomeIcon icon={faSave} />
                          </span>
                        </Tooltip>
                        <Tooltip text={"Print"} position={"top"}>
                          <span className='text-orange-500 cursor-pointer mr-4' onClick={() => handleRecordPrint(record._id)}>
                            <FontAwesomeIcon icon={faPrint} />
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
    </div>
    <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4">
      <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-xs lg:text-sm">
          © 2026 Think5Whys Global DeepTech Solutions.
        </div>
        <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
          <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
          <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
          <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
          <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
        </div>
      </div>
    </footer>
  </div>
  );
};

export default Think5WhysExtensionDB;
